import React, { useState } from "react";
import { Steps } from "antd";
import ReviewCheckList from "./components/ReviewCheckList";
import ManagePaymentMethod from "./components/ManagePaymentMethod";
import ManageAddress from "./components/ManageAddress";
import { CreditCardOutlined, FormOutlined, HomeOutlined, WarningOutlined } from "@ant-design/icons";
import SubTotal from "./components/SubTotal";

const Index = () => {
  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const steps = [
    { title: "Address", content: <ManageAddress next={next} />, },
    { title: "Payment Method", content: <ManagePaymentMethod next={next} prev={prev} />, },
    { title: "Review", content: <ReviewCheckList prev={prev} />, },
  ];

  const getIcon = (current) => {
    if (current === 1) {
      return <HomeOutlined />;
    } else if (current === 2) {
      return <CreditCardOutlined />;
    } else if (current === 3) {
      return <FormOutlined />;
    } else {
      return <WarningOutlined />;
    }
  };

  const items = steps.map((item, index) => ({
    key: item.title,
    title: item.title,
    icon: getIcon(index + 1),
  }));
  // console.log(items);
  const contentStyle = {
    margin: 14,
  };

  return (
    <>
      <div className="container">
        <div className="row mb-3 mt-5">
          <div className="col">
            <h1>Checkout</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-8 ">
            <Steps current={current} items={items} labelPlacement="vertical" className="min-h-5 min-h-md-auto" />
            <div style={contentStyle}>{steps[current].content}</div>
            <div style={{ marginTop: 24, }}>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <SubTotal current={current} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Index;
